import React, { useEffect, useState} from "react"; 
import { useTranslation } from "react-i18next";
import { CREDIT_API_URL, ASSETS_URL } from "../../constants";
import useUtmStore from '../../store/useUtmStore';
import getClientInfo from '../../utility/getClientInfo';
const LenderFormSection = () => {
    const { t } = useTranslation('commercialVehicleLoanPage'); // or the appropriate translation namespace
    
    // Define missing state variables
    const [productType] = useState("Lender Page"); // or get from props
    const [loanAmount] = useState(1); // or get from props
    const [isMobileValid, setIsMobileValid] = useState(false);
    const utm = useUtmStore(state => state.utm || {});
    const { browserName, deviceType, userAgent } = getClientInfo();
    const [formData, setFormData] = useState({
        productType: productType,
        loanAmount: 1,
        mobile: "",
        name: "",
        businessName: "",
    });

    // Update formData whenever loanAmount changes
    useEffect(() => {
        setFormData(prevData => ({
            ...prevData,
            loanAmount: loanAmount,
            productType: productType
        }));
    }, [loanAmount, productType]);

    // Handle input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: name === "mobile" ? (parseInt(value, 10) || "") : value,
        });
        if (name === "mobile") {
            setIsMobileValid(/^[6-9]\d{9}$/.test(value)); // Update validity based on regex
        }
    };

    const handleSubmit = async (e, isMobileForm = false) => {
        e.preventDefault();
        const controller = new AbortController();
        const messageDiv = isMobileForm ? document.getElementById("frm-error-mobile") : document.getElementById("frm-error");
        const timeout = setTimeout(() => controller.abort(), 6000);
        
        try {
            // Ensure loanAmount is included in the submission
            const submissionData = {
                ...formData,
                loanAmount: loanAmount,
                utmCampaign: utm.utmCampaign || "GrowBizh",
                utmSource: utm.utmSource || null,
                utmMedium: utm.utmMedium || null,
                browserName: browserName || null,
                deviceType: deviceType || null,
            };

            const response = await fetch("" + CREDIT_API_URL + "create-lead", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(submissionData),
            });
            
            clearTimeout(timeout);
            
            if (response.status !== 200) {
                const v_result = await response.json();
                throw new Error(v_result.message);
            }
            
            // Display success message in the HTML
            messageDiv.style.color = "green";
            messageDiv.textContent = "Thanks!! We will get back to you soon.";
            messageDiv.style.display = "block";
            
            setFormData({
                productType: productType,
                loanAmount: loanAmount,
                mobile: "",
                name: "",
                businessName: "",
            });
            setIsMobileValid(false);

        } catch (error) {
            console.error("Error submitting form:", error);
            messageDiv.style.color = "red";
            messageDiv.textContent = error.message;
            messageDiv.style.display = "block";

            setFormData({
                productType: productType,
                loanAmount: loanAmount,
                mobile: "",
                name: "",
                businessName: "",
            });
            setIsMobileValid(false);
        }
        
        setTimeout(() => messageDiv.style.display = "none", 3000);
    };

    return (
        <section className="form-section-container">
            <div className='commercial-vehicle-form-section' >
                <div className='commercial-vehicle-form-section-top'>
                    <div className='commercial-vehicle-form-section-top-description'>
                        {t('commercial-vehicle-form-section-description.line1')} {t('commercial-vehicle-form-section-description.line2')}
                    </div>
                </div>

                <div className='commercial-vehicle-form-section-bottom'>
                    <div className="commercial-vehicle-form">
                        <form className="form-horizontal commercial-vehicle-form-content" onSubmit={handleSubmit}>
                            <div className="form-group commercial-vehicle-input-group">
                                <img src={`${ASSETS_URL}images/mobile.svg`} alt="" />
                                <input 
                                    type="text" 
                                    className={`form-control ${isMobileValid ? 'valid' : ''} input-field`} 
                                    required 
                                    placeholder="" 
                                    name="mobile" 
                                    value={formData.mobile}
                                    onChange={handleChange} 
                                    id="myInput" 
                                    autoComplete='off' 
                                />
                                <label htmlFor="myInput" className="emi-placeholder">
                                    {t('commercial-vehicle-form-placeholder')}
                                </label>
                                {isMobileValid && <img src='/images/form-mobile-tick-icon-desktop.svg' alt='' className='valid-icon' />}
                            </div>

                            <div className="form-group commercial-vehicle-form-button">
                                <button className="btn-small-mobile btn-commercial-vehicle-form btn-primary" disabled={!isMobileValid}>
                                    {t('commercial-vehicle-form-button')}
                                </button>
                            </div>
                            <div><div id='frm-error'></div></div>
                        </form>
                    </div>

                    {/*Mobile */}
                    <div className="commercial-vehicle-form-mobile">
                        <form className="form-horizontal commercial-vehicle-form-mobile-content" onSubmit={(e) => handleSubmit(e, true)}>
                            <div className="form-group commercial-vehicle-mobile-input-group">
                                <img src={`${ASSETS_URL}images/mobile.svg`} alt="" />
                                <input 
                                    type="text" 
                                    className={`form-control ${isMobileValid ? 'valid' : ''} input-field`} 
                                    required 
                                    placeholder="" 
                                    name="mobile" 
                                    value={formData.mobile}
                                    onChange={handleChange} 
                                    autoComplete='off' 
                                    id="contact"
                                />
                                <label htmlFor="contact" className="placeholder">
                                    {t('commercial-vehicle-form-placeholder')}
                                </label>
                                {isMobileValid && <img src='/images/form-mobile-tick-icon-desktop.svg' alt='' className='valid-icon' />}
                            </div>
                            <div className="form-group" id='frm-error-mobile'></div>
                            <div className="form-group commercial-vehicle-mobile-form-button mt-1 mb-1">
                                <button className="btn-commercial-vehicle-mobile-form btn-primary" disabled={!isMobileValid}>
                                    {t('commercial-vehicle-form-button')}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default LenderFormSection;